import React from "react";
import { ShieldCheck, Target, Eye, User } from "lucide-react";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { SEO, breadcrumbSchema } from "../components/SEO";

const TEAM = [
    {
        name: "lamchachti mohamed",
        role: "Rédacteur en chef",

    },

];

const APropos = () => {
    return (
        <div data-testid="apropos-page">
            <SEO
                title="À propos de Pronospot | Notre équipe et méthodologie"
                description="Découvrez l'équipe d'experts de Pronospot.com, notre méthodologie d'analyse transparente et notre politique sur l'affiliation."
                jsonLd={breadcrumbSchema([
                    { name: "Accueil", url: "https://pronospot.com/" },
                    { name: "À propos", url: "https://pronospot.com/a-propos" },
                ])}
            />
            <section className="container-x pt-10 pb-6">
                <Breadcrumbs items={[{ label: "À propos" }]} />
                <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white tracking-tighter">
                    À propos de Pronospot
                </h1>
                <p className="text-gray-400 mt-4 max-w-2xl text-lg">
                    Une équipe de parieurs passionnés, une méthodologie
                    rigoureuse, une indépendance totale vis-à-vis des
                    opérateurs.
                </p>
            </section>

            {/* Team */}
            <section className="container-x py-14" data-testid="team-section">
                <h2 className="font-heading text-3xl font-bold text-white mb-8">
                    Notre équipe
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {TEAM.map((t) => (
                        <div
                            key={t.name}
                            className="card-elev p-6 text-center"
                            data-testid={`team-card-${t.name.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            <div className="w-20 h-20 mx-auto rounded-full bg-[#1E3A5F] border-2 border-[#00C853]/40 flex items-center justify-center mb-4">
                                <User
                                    className="text-[#00C853]"
                                    size={36}
                                />
                            </div>
                            <h3 className="font-heading font-bold text-white text-lg">
                                {t.name}
                            </h3>
                            <p className="text-[#00C853] text-sm font-semibold mt-1">
                                {t.role}
                            </p>
                            <p className="text-sm text-gray-400 mt-3 leading-relaxed">
                                {t.bio}
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Method */}
            <section
                className="container-x py-14"
                data-testid="method-section"
            >
                <h2 className="font-heading text-3xl font-bold text-white mb-8">
                    Notre méthode d'analyse
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {[
                        {
                            icon: Target,
                            title: "Critères objectifs",
                            desc: "Cotes, marchés, bonus, app mobile, paiements, service client : 8 critères pondérés.",
                        },
                        {
                            icon: Eye,
                            title: "Tests réels",
                            desc: "Nous ouvrons un compte sur chaque opérateur et testons l'expérience de bout en bout.",
                        },
                        {
                            icon: ShieldCheck,
                            title: "Mises à jour mensuelles",
                            desc: "Les notes sont révisées chaque mois pour refléter les évolutions de chaque plateforme.",
                        },
                    ].map(({ icon: Icon, title, desc }) => (
                        <div key={title} className="card-elev p-6">
                            <div className="w-12 h-12 rounded-xl bg-[#00C853]/10 border border-[#00C853]/30 flex items-center justify-center mb-4">
                                <Icon className="text-[#00C853]" size={22} />
                            </div>
                            <h3 className="font-heading font-bold text-white mb-2">
                                {title}
                            </h3>
                            <p className="text-sm text-gray-400 leading-relaxed">
                                {desc}
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Transparency */}
            <section className="container-x py-14">
                <div className="card-elev p-8 border-l-4 border-l-[#00C853]">
                    <h2 className="font-heading text-2xl font-bold text-white mb-3">
                        Notre indépendance totale
                    </h2>
                    <p className="text-gray-300 leading-relaxed mb-3">
                        Pronospot.com est un site de comparaison entièrement
                        indépendant. Nous ne percevons{" "}
                        <strong className="text-white">
                            aucune commission sur vos mises ou vos pertes
                        </strong>{" "}
                        de la part des bookmakers partenaires.
                    </p>
                    <p className="text-gray-300 leading-relaxed">
                        Nos classements et nos analyses reflètent uniquement la qualité réelle
                        des opérateurs et la pertinence de leurs cotes, de manière totalement objective, neutre et gratuite pour les utilisateurs.
                    </p>
                </div>
            </section>
        </div>
    );
};

export default APropos;
